/*
 * @Author: Zyr
 * @Date: 2021-02-03 22:51:13
 * @LastEditTime: 2021-10-26 21:19:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\main.js
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

import ElementUI from 'element-ui'

import App from './App'
import axios from 'axios'
import echarts from 'echarts'
import * as d3 from 'd3'
import animated from 'animate.css'
import cookie from 'vue-cookie'
// 1月13日 引入iconfont
import './css/iconfont/iconfont.css'
// import VideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

import './V3/css/element-#12C287/index.css'
import drag from "v-drag"
// const drag = require("v-drag");

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.use(Vuex)
Vue.use(animated)
Vue.use(drag);
// Vue.use(axios)
Vue.prototype.axios = axios
Vue.prototype.$http = axios
// Vue.use(VideoPlayer)

Vue.prototype.$echarts = echarts
Vue.prototype.$d3 = d3
Vue.prototype.$cookie = cookie
window.d3 = d3     // 暂时设置为全局变量



const store = new Vuex.Store({
    state: {
        // 右边侧边栏 搜索结果提示
        search_result_tip: false,
        userName: '游客',
        userEmail: '314864663@qq.com',
        userUnit: '南京师范大学',
        userWork: '学生',
        userLv: 'LV2',
        userPt: 20,
        password: '123456',
        is_login_success: false,
        is_case_study: false,
        // 记录menu展开项
        // menu_active:'基本信息',
        // menu_opened: ["1"],
        menu_active: '6',
        // 我的账户页面显示的模块
        // 账户信息
        isMainInfo: true,
        isChangePassword: false,


        // 历史操作
        isAddLocation: false,
        isChangeLocation: false,

        // 我的积分
        isPointInfo: false,
        isPrizeInfo: false,

        // 页面显示
        comVisParam: {
            // 定位图例是否显示
            showLegend: false,
            comGeoSurveyProject: true,
            comGeoSurveyMap: false,
            comMapPositioning: false,
            // 记录侧边栏状态
            isUnfold: true,

        },
        // V3版本公共变量
        // 记录menu展开项
        V3menuActive: "'1'",
        V3mail: '',
        V3loginState: false,
        V3loginRole:'',
        V3locationclickflag: false


    }
})

Vue.directive('title', {
    inserted: function (el, binding) {
        document.title = el.dataset.title
    }

})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


export default {
    store
}




// WEBPACK FOOTER //
// ./src/main.js